module.exports = __webpack_public_path__ + "media/images/athletes/2754-8ec931ac7e7d7ed0ad7cae419cc46c08.png";